import { render, staticRenderFns } from "./o-project-nav.vue?vue&type=template&id=48043a22&scoped=true&"
import script from "./o-project-nav.vue?vue&type=script&lang=js&"
export * from "./o-project-nav.vue?vue&type=script&lang=js&"
import style0 from "./o-project-nav.vue?vue&type=style&index=0&id=48043a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48043a22",
  null
  
)

export default component.exports